<template>
  <div>
    <div class="box">
      <div class="columns is-vcentered">
        <div class="column">
          <h3 class="title is-3 mb-0">
            <span class="has-text-success">
              <b-icon icon="shield-star" />
            </span>
            <span>{{ title }}</span>
          </h3>
          <div class="content">
            <p>{{copy}}</p>
          </div>
        </div>
        <div class="column is-hidden-mobile">
          <h4 class="title is-4 has-text-centered">{{ submodules.length }} Modules</h4>
        </div>
        <div class="column has-text-right has-text-left-mobile">
          <b-button @click="navToSubmodules" icon-right="chevron-right-circle" type="is-success">Begin</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    code: String,
    title: String,
    copy: String,
    submodules: Array,
  },
  methods: {
    navToSubmodules: function () {
      localStorage.setItem('submodules', JSON.stringify(this.submodules));
      localStorage.setItem('submodulesTitle', this.title);
      localStorage.setItem('submodulesCopy', this.copy);
      localStorage.setItem('submodulesCode', this.code);

      this.$router.push('/modules/submodules');
    }
  }
}
</script>

<style scoped>

</style>